{
  "fr-FR": {
    "change": "changer la langue",
    "select": "sélectionnez la langue de votre choix",
    "validate": "valider"
  },
  "en-US": {
    "change": "change the language",
    "select": "select the language you want to use",
    "validate": "validate"
  },
  "es-ES": {
    "change": "change the language",
    "select": "select the language you want to use",
    "validate": "validate"
  },
  "de-DE": {
    "change": "change the language",
    "select": "select the language you want to use",
    "validate": "validate"
  }
}
